/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  AccessTokenResponse,
  ActivateEnrolmentRequest,
  ActivateEnrolmentResponse,
  CheckTokenRequest,
  CreateEnrolmentRequest,
  CreateEnrolmentResponse,
  GetAccessTokenRequest,
  GetLoginTypeParams,
  GetUnauthenticatedEnrolmentsRequest,
  HandleSamlLogoutRequestParams,
  HandleSamlResponseParams,
  LoginRequest,
  LoginResponse,
  LoginTypeResponse,
  LoginWithPinRequest,
  LogoutRequest,
  MakeEnrolmentDefaultRequest,
  MultiFactorCodeRequest,
  MultiFactorCodeResponse,
  MultiFactorEnrolmentDto,
  ResetPasswordRequest,
  ResetPasswordResponse,
  RevokeEnrolmentRequest,
  RevokeEnrolmentResponse,
  SetPasswordRequest,
  SetPasswordResponse,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ApiAuthController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-auth-controller
   * @name Logout
   * @request PUT:/api/v1/logout
   */
  logout = (data: LogoutRequest, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/logout`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static logoutPath = '/v1/logout'
  static logoutMethod = 'PUT'
  /**
   * No description
   *
   * @tags api-auth-controller
   * @name SetPassword
   * @request POST:/api/v1/set-password/{userId}/{token}
   */
  setPassword = (
    userId: string,
    token: string,
    data: SetPasswordRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<SetPasswordResponse, any>({
      path: `/v1/set-password/${userId}/${token}`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static setPasswordPath = '/v1/set-password/${userId}/${token}'
  static setPasswordMethod = 'POST'
  /**
   * No description
   *
   * @tags api-auth-controller
   * @name TriggetResetPassword
   * @request POST:/api/v1/reset-password
   */
  triggetResetPassword = (data: ResetPasswordRequest, params: RequestParams = {}) =>
    this.http.request<ResetPasswordResponse, any>({
      path: `/v1/reset-password`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static triggetResetPasswordPath = '/v1/reset-password'
  static triggetResetPasswordMethod = 'POST'
  /**
   * No description
   *
   * @tags api-auth-controller
   * @name LoginAndGetRefreshToken
   * @request POST:/api/v1/login
   */
  loginAndGetRefreshToken = (data: LoginRequest, params: RequestParams = {}) =>
    this.http.request<LoginResponse, any>({
      path: `/v1/login`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static loginAndGetRefreshTokenPath = '/v1/login'
  static loginAndGetRefreshTokenMethod = 'POST'
  /**
   * No description
   *
   * @tags api-auth-controller
   * @name LoginWithPinAndGetRefreshToken
   * @request POST:/api/v1/login-with-pin
   */
  loginWithPinAndGetRefreshToken = (data: LoginWithPinRequest, params: RequestParams = {}) =>
    this.http.request<LoginResponse, any>({
      path: `/v1/login-with-pin`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static loginWithPinAndGetRefreshTokenPath = '/v1/login-with-pin'
  static loginWithPinAndGetRefreshTokenMethod = 'POST'
  /**
   * No description
   *
   * @tags api-auth-controller
   * @name HandleSamlResponse
   * @request POST:/api/v1/handle_saml_response/{organizationId}
   */
  handleSamlResponse = (
    { organizationId, ...query }: HandleSamlResponseParams,
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/v1/handle_saml_response/${organizationId}`,
      method: 'POST',
      query: query,
      ...params,
    })

  static handleSamlResponsePath = '/v1/handle_saml_response/${organizationId}'
  static handleSamlResponseMethod = 'POST'
  /**
   * No description
   *
   * @tags api-auth-controller
   * @name GetActiveEnrolmentsForUnauthorizedUser
   * @request POST:/api/v1/enrolments
   */
  getActiveEnrolmentsForUnauthorizedUser = (
    data: GetUnauthenticatedEnrolmentsRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<MultiFactorEnrolmentDto[], any>({
      path: `/v1/enrolments`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static getActiveEnrolmentsForUnauthorizedUserPath = '/v1/enrolments'
  static getActiveEnrolmentsForUnauthorizedUserMethod = 'POST'
  /**
   * No description
   *
   * @tags api-auth-controller
   * @name Revoke
   * @request POST:/api/v1/enrolments/revoke
   */
  revoke = (data: RevokeEnrolmentRequest, params: RequestParams = {}) =>
    this.http.request<RevokeEnrolmentResponse, any>({
      path: `/v1/enrolments/revoke`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static revokePath = '/v1/enrolments/revoke'
  static revokeMethod = 'POST'
  /**
   * No description
   *
   * @tags api-auth-controller
   * @name MakeDefault
   * @request POST:/api/v1/enrolments/make-default
   */
  makeDefault = (data: MakeEnrolmentDefaultRequest, params: RequestParams = {}) =>
    this.http.request<MultiFactorEnrolmentDto[], any>({
      path: `/v1/enrolments/make-default`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static makeDefaultPath = '/v1/enrolments/make-default'
  static makeDefaultMethod = 'POST'
  /**
   * No description
   *
   * @tags api-auth-controller
   * @name Enrol
   * @request POST:/api/v1/enrolments/enrol
   */
  enrol = (data: CreateEnrolmentRequest, params: RequestParams = {}) =>
    this.http.request<CreateEnrolmentResponse, any>({
      path: `/v1/enrolments/enrol`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static enrolPath = '/v1/enrolments/enrol'
  static enrolMethod = 'POST'
  /**
   * No description
   *
   * @tags api-auth-controller
   * @name Activate
   * @request POST:/api/v1/enrolments/activate
   */
  activate = (data: ActivateEnrolmentRequest, params: RequestParams = {}) =>
    this.http.request<ActivateEnrolmentResponse, any>({
      path: `/v1/enrolments/activate`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static activatePath = '/v1/enrolments/activate'
  static activateMethod = 'POST'
  /**
   * No description
   *
   * @tags api-auth-controller
   * @name CheckAccessToken
   * @request POST:/api/v1/check-access-token
   */
  checkAccessToken = (data: CheckTokenRequest, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/check-access-token`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static checkAccessTokenPath = '/v1/check-access-token'
  static checkAccessTokenMethod = 'POST'
  /**
   * No description
   *
   * @tags api-auth-controller
   * @name GetMultiFactorCodeForLogin
   * @request POST:/api/v1/auth_code
   */
  getMultiFactorCodeForLogin = (data: MultiFactorCodeRequest, params: RequestParams = {}) =>
    this.http.request<MultiFactorCodeResponse, any>({
      path: `/v1/auth_code`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static getMultiFactorCodeForLoginPath = '/v1/auth_code'
  static getMultiFactorCodeForLoginMethod = 'POST'
  /**
   * No description
   *
   * @tags api-auth-controller
   * @name ExchangeRefreshTokenForAccess
   * @request POST:/api/v1/access_token
   */
  exchangeRefreshTokenForAccess = (data: GetAccessTokenRequest, params: RequestParams = {}) =>
    this.http.request<AccessTokenResponse, any>({
      path: `/v1/access_token`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static exchangeRefreshTokenForAccessPath = '/v1/access_token'
  static exchangeRefreshTokenForAccessMethod = 'POST'
  /**
   * No description
   *
   * @tags api-auth-controller
   * @name HandleSamlLogoutRequest
   * @request GET:/api/v1/handle_saml_logout_request/{organizationId}
   */
  handleSamlLogoutRequest = (
    { organizationId, ...query }: HandleSamlLogoutRequestParams,
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/v1/handle_saml_logout_request/${organizationId}`,
      method: 'GET',
      query: query,
      ...params,
    })

  static handleSamlLogoutRequestPath = '/v1/handle_saml_logout_request/${organizationId}'
  static handleSamlLogoutRequestMethod = 'GET'
  /**
   * No description
   *
   * @tags api-auth-controller
   * @name GetSamlRequest
   * @request GET:/api/v1/get_saml_request/{organizationId}
   */
  getSamlRequest = (organizationId: string, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/get_saml_request/${organizationId}`,
      method: 'GET',
      ...params,
    })

  static getSamlRequestPath = '/v1/get_saml_request/${organizationId}'
  static getSamlRequestMethod = 'GET'
  /**
   * No description
   *
   * @tags api-auth-controller
   * @name GetLoginType
   * @request GET:/api/v1/get_login_type
   */
  getLoginType = (query: GetLoginTypeParams, params: RequestParams = {}) =>
    this.http.request<LoginTypeResponse, any>({
      path: `/v1/get_login_type`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static getLoginTypePath = '/v1/get_login_type'
  static getLoginTypeMethod = 'GET'
  /**
   * No description
   *
   * @tags api-auth-controller
   * @name GetActiveEnrolmentsForAuthorizedUser
   * @request GET:/api/v1/enrolments-authenticated
   */
  getActiveEnrolmentsForAuthorizedUser = (params: RequestParams = {}) =>
    this.http.request<MultiFactorEnrolmentDto[], any>({
      path: `/v1/enrolments-authenticated`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getActiveEnrolmentsForAuthorizedUserPath = '/v1/enrolments-authenticated'
  static getActiveEnrolmentsForAuthorizedUserMethod = 'GET'
}
